export const pastelCategoricalDefault: string[] = [];
export const pastelCategoricalMixed: string[] = [];
